export const FETCH_CERTIFICATES_REQUEST = 'FETCH_CERTIFICATES_REQUEST';
export const FETCH_CERTIFICATES_SUCCESS = 'FETCH_CERTIFICATES_SUCCESS';
export const FETCH_CERTIFICATES_FAILURE = 'FETCH_CERTIFICATES_FAILURE';

export const FETCH_CERTIFICATE_DETAIL_REQUEST = 'FETCH_CERTIFICATE_DETAIL_REQUEST';
export const FETCH_CERTIFICATE_DETAIL_SUCCESS = 'FETCH_CERTIFICATE_DETAIL_SUCCESS';
export const FETCH_CERTIFICATE_DETAIL_FAILURE = 'FETCH_CERTIFICATE_DETAIL_FAILURE';

export const CREATE_CERTIFICATE_REQUEST = 'CREATE_CERTIFICATE_REQUEST';
export const CREATE_CERTIFICATE_SUCCESS = 'CREATE_CERTIFICATE_SUCCESS';
export const CREATE_CERTIFICATE_FAILURE = 'CREATE_CERTIFICATE_FAILURE';

export const DELETE_CERTIFICATES_BY_TASK_REQUEST = 'DELETE_CERTIFICATES_BY_TASK_REQUEST';
export const DELETE_CERTIFICATES_BY_TASK_SUCCESS = 'DELETE_CERTIFICATES_BY_TASK_SUCCESS';
export const DELETE_CERTIFICATES_BY_TASK_FAILURE = 'DELETE_CERTIFICATES_BY_TASK_FAILURE';

export const CHECK_CERTIFICATE_PURCHASE_STATUS_REQUEST = 'CHECK_CERTIFICATE_PURCHASE_STATUS_REQUEST';
export const CHECK_CERTIFICATE_PURCHASE_STATUS_SUCCESS = 'CHECK_CERTIFICATE_PURCHASE_STATUS_SUCCESS';
export const CHECK_CERTIFICATE_PURCHASE_STATUS_FAILURE = 'CHECK_CERTIFICATE_PURCHASE_STATUS_FAILURE';

export const MARK_CERTIFICATE_PURCHASED_REQUEST = 'MARK_CERTIFICATE_PURCHASED_REQUEST';
export const MARK_CERTIFICATE_PURCHASED_SUCCESS = 'MARK_CERTIFICATE_PURCHASED_SUCCESS';
export const MARK_CERTIFICATE_PURCHASED_FAILURE = 'MARK_CERTIFICATE_PURCHASED_FAILURE';

